export default function PurchaseModel(dict) {
    this.adsMessage = dict.AdsMessage;
    this.agencyID = dict.AgencyID;
    this.agencyName = dict.AgencyName;
    this.barcode = dict.Barcode;

    if(!this.barcode)
        this.barcode = "";

    this.categoryID = dict.CategoryID;
    this.caption = dict.Caption;
    this.condition = dict.Condition;
    this.currentDate = dict.CurrentDate;
    this.delivered = dict.Delivered;
    this.detail = dict.Detail;
    this.discount = dict.Discount;
    this.expireIn = dict.ExpireIn;
    this.fullImageUrl = dict.FullImageUrl;
    this.hasWinner = dict.HasWinner;
    this.id = dict.ID;
    this.info1 = dict.Info1;
    this.info2 = dict.Info2;
    this.info3 = dict.Info3;
    this.info4 = dict.Info4;
    this.info5 = dict.Info5;
    this.installAppIosSchema = dict.InstallAppIosSchema;
    this.installAppUrl = dict.InstallAppUrl;
    this.installedAppDate = dict.InstalledAppDate;
    this.installingMessage = dict.InstallingMessage;
    this.installPackageName = dict.InstallPackageName;
    this.interfaceDisplay = dict.InterfaceDisplay;
    this.isCampaignTopup = dict.IsCampaignTopup;
    this.isConditionPass = dict.IsConditionPass;
    this.isInstalledApp = dict.IsInstalledApp;
    this.isNotAutoUse = dict.IsNotAutoUse;
    this.isShipped = dict.IsShipped;
    this.isSpecificPrintVoucher = dict.IsSpecificPrintVoucher;
    this.isUsed = dict.IsUsed;
    this.isWinner = dict.IsWinner;
    this.itemNumber = dict.ItemNumber;
    this.minutesValidAfterUsed = dict.MinutesValidAfterUsed;
    this.modifyDate = dict.ModifyDate;
    this.name = dict.Name;
    this.originalPrice = dict.OriginalPrice;
    this.otherPointPerUnit = dict.OtherPointPerUnit;
    this.parcelNo = dict.PacelNo;
    this.parentCategoryID = dict.ParentCategoryID;
    this.pointPerUnit = dict.PointPerUnit;
    this.pointType = dict.PointType;
    this.pricePerUnit = dict.PricePerUnit;
    this.privilegeMessage = dict.PrivilegeMessage;
    this.privilegeMessageFormat = dict.PrivilegeMessageFormat;

    this.redeemDate = dict.RedeemDate;

    this.redeemKey = dict.RedeemKey;
    this.refPaymentTranId = dict.RefPaymentTranId;
    this.serial = dict.Serial;
    this.shippedStatus = dict.ShippedStatus;
    this.shippingDate = dict.ShippingDate;
    this.styleSize = dict.StyleSize;
    this.styleType = dict.StyleType;
    this.type = dict.Type;
    this.usedDate = dict.UsedDate;
    this.verifyingMessage = dict.VerifyingMessage;
    this.verifyTypeAndroid = dict.VerifyTypeAndroid;
    this.verifyTypeIos = dict.VerifyTypeIos;
    this.voucherExpireDate = dict.VoucherExpireDate;
    this.website = dict.Website;
    this.winnerDate = dict.WinnerDate;

    this.iimmpactSerial = dict.iimmpact_serial;
    this.iimmpactPin = dict.iimmpact_pin;
    this.iimmpactExpiry = dict.iimmpact_expiry;
    this.iimmpactVoucherlink = dict.iimmpact_voucherlink;

    if (this.fullImageUrl) {
        if(this.fullImageUrl.indexOf("-large") < 0) {
            var newString = this.fullImageUrl.replace("?", "-large?");
            this.fullImageUrl = newString;
        }
    }

    this.updateAfterRedeem = function (dict) {
        this.redeemCount = dict.RedeemCount;
        if (dict.RedeemDate)
            this.redeemDate = dict.RedeemDate;

        this.serial = dict.Serial;
        this.nextRedeemDate = dict.NextRedeemDate;
        this.useCount = dict.UseCount;
        this.qty = dict.Qty;
        this.isConditionPass = dict.IsConditionPass;
        this.adsMessage = dict.AdsMessage;
        this.expireIn = dict.ExpireIn;
        this.isNotAutoUse = dict.IsNotAutoUse;
        this.privilegeMessage = dict.PrivilegeMessage;

        if (dict.buzzebees)
            this.buzzebees = dict.buzzebees;

        if (dict.privilegeMessageEN)
            this.privilegeMessageEN = dict.privilegeMessageEN;

        if (dict.PrivilegeMessageEN)
            this.privilegeMessageEN = dict.PrivilegeMessageEN;

        this.privilegeMessageFormat = dict.PrivilegeMessageFormat;
        this.pointType = dict.PointType;
        this.conditionAlert = dict.ConditionAlert;
        this.currentDate = dict.CurrentDate;

        // support purchase
        this.parcelNo = dict.ParcelNo;
        this.isShipped = dict.IsShipped;
        if (dict.RedeemKey)
            this.redeemKey = dict.RedeemKey;

        // Replace serial in privilege message
        if (this.privilegeMessage && this.serial)
            this.privilegeMessage = this.privilegeMessage.replace("<serial>", this.serial);

        if (this.privilegeMessageEN && this.serial)
            this.privilegeMessageEN = this.privilegeMessageEN.replace("<serial>", this.serial)
    }

    this.setPurchaseExpired = function () {
        this.expireIn = -1
        this.serial = 'XXXXXXX';
    }
}
